import React from 'react';

import { EmailLink } from '@zimpel/common/components/Links';
import { H1, H2 } from '@zimpel/common/components/Headlines';
import { ContentBody, ContentHeader, ContentNarrow } from '@zimpel/common/components/ContentLayout';

const PrivacyNotice: React.FC = () => (
  <>
    <ContentHeader>
      <ContentNarrow>
        <H1>Datenschutzerklärung</H1>
      </ContentNarrow>
    </ContentHeader>
    <ContentBody>
      <ContentNarrow>
        <p>
          Der Schutz Ihrer personenbezogenen Daten ist für uns ein wichtiges Anliegen. Im Folgenden erläutern
          wir, welche Informationen wir während der Nutzung unserer Anwendung zimpel erfassen und wie diese genutzt
          werden.
        </p>
        <H2>Sicherheit</H2>
        <p>
          news aktuell trifft alle notwendigen Sicherheitsmaßnahmen, um personenbezogene Daten vor Verlust
          und Missbrauch zu schützen. So werden alle Daten u.A. in einer sicheren Betriebsumgebung gespeichert,
          die von außen nicht zugänglich ist. Die Kommunikation mit uns über die Anwendung wird durch die so
          genannte Secure Socket Layer-Technologie (SSL) verschlüsselt. Das bedeutet, dass die Kommunikation
          zwischen Ihrem Computer und unseren Servern unter Einsatz eines anerkannten Verschlüsselungsverfahrens
          erfolgt, wenn Ihr Browser SSL unterstützt. Sofern Sie nähere Infos zu den technischen Sicherheitsmaßnahmen
          der Anwendung zimpel benötigen, fordern Sie gern unsere TOMs (Technisch-Organisatorischen Maßnahmen zur
          Datensicherheit) an.
        </p>
        <H2>Einsatz eines Zählpixels beim zimpel-Mailingtool</H2>
        <p>
          Um den Kunden Öffnungsraten ihrer Mailings anzeigen zu können, nutzt news aktuell bei Mailaussendungen
          über zimpel einen einfachen Zählpixel. Dieser zählt ausschließlich die Anzahl der Öffnungen pro Mailing
          innerhalb von 24 h nach Versand, ohne Zuordnung zum Empfänger. Dieser Prozess findet ausschließlich in
          unserem hauseigenen Rechenzentrum statt und es wird keine Software eines externen Dienstleisters eingesetzt.
          Der Zählmechanismus wird ausschließlich dazu genutzt, den jeweiligen Kunden entsprechende Öffnungsraten
          anzeigen zu können.
        </p>
        <H2>Einsatz von Bugsnag und NewRelic</H2>
        <p>
          Um die Stabilität der Anwendung zu überwachen und mögliche Fehler zu finden, setzt news aktuell die Tools
          Bugsnag und NewRelic ein. Dabei verzichten wir grundsätzlich darauf, personenbezogene Daten zu speichern oder
          zu nutzen / auszuwerten.
        </p>
        <H2>Rechte betroffener Personen</H2>
        <p>
          Die betroffene Person hat folgende Rechte: Auskunftsrecht (Art. 15 DSGVO), Recht auf Berichtigung
          (Art. 16 DSGVO) Widerspruchsrecht (Art. 21 DSGVO), Recht auf Löschung (Art. 17 DSGVO), Recht auf Einschränkung
          der Verarbeitung (Art. 18f. DSGVO), Recht auf Datenübertragbarkeit (Art. 20 DSGVO). Bitte beachten Sie, dass
          wir bei derartigen Anfragen sicherstellen müssen, dass es sich tatsächlich um die betroffene Person handelt.
          Die betroffene Person hat das Recht, bei einer Datenschutzbehörde Beschwerde einzulegen.
        </p>
        <p>
          Wenn Sie Fragen hinsichtlich der Verarbeitung Ihrer persönlichen Daten haben, können Sie sich an unsere
          Datenschutzbeauftragte wenden:
          <br />
          Vera Walter
          <br />
          Tel: +49 (0)40 4113 32877
          <br />
          Mail:
          {' '}
          <EmailLink>datenschutz@newsaktuell.de</EmailLink>
        </p>
      </ContentNarrow>
    </ContentBody>
  </>
);

export default PrivacyNotice;
